"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reactVirtual = require("@tanstack/react-virtual");
var _SelectForSearchCollectionsModal = require("../../../collections/components/SelectForSearchCollectionsModal");
var _Input = _interopRequireDefault(require("../../../ui/Input"));
var _Checkbox = _interopRequireDefault(require("../../../ui/Checkbox"));
var _CircleLoader = _interopRequireDefault(require("../../../ui/CircleLoader"));
var _Alert = _interopRequireDefault(require("../../../ui/Alert"));
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _actions = require("../../store/actions");
var _selectors = require("../../store/selectors");
var _HeartIcon = _interopRequireDefault(require("./HeartIcon"));
var _styles = _interopRequireDefault(require("./styles"));
var _withProps = _interopRequireDefault(require("./withProps"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var getHotelNames = function getHotelNames(hotel) {
  return R.map(function (name) {
    return R.concat(R.toLower(name), R.concat(" ".concat(hotel.stars, "*"), hotel.secondaryStars ? "/".concat(hotel.secondaryStars, "*") : ''));
  }, [hotel.name, hotel.nameAlt]);
};
var stringifyHotelsFromCollection = function stringifyHotelsFromCollection(hotels) {
  return R.map(R.toString, hotels);
};
var hotelToNumbers = function hotelToNumbers(hotels) {
  return R.map(Number, hotels);
};
var searchHotelsByString = function searchHotelsByString(searchString) {
  return function (hotels) {
    return R.filter(function (hotel) {
      return R.any(function (name) {
        return R.includes(R.toLower(searchString), name) || R.all(function (word) {
          return R.includes(R.toLower(word), name);
        }, R.split(' ', searchString));
      }, getHotelNames(hotel));
    }, hotels);
  };
};
var HotelName = function HotelName(_ref) {
  var name = _ref.name,
    stars = _ref.stars,
    secondaryStars = _ref.secondaryStars,
    cityName = _ref.cityName,
    districtName = _ref.districtName;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.hotelName
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.colorBlack
  }, name, ' ', stars, "*", secondaryStars && "/".concat(secondaryStars, "*")), ' ', cityName, districtName && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ",", ' ', districtName));
};
var CollectionsModalTrigger = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", "\n"])), function (props) {
  return props.theme.primaryColor;
});
var StyledSelectedItem = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background: ", "\n"])), function (props) {
  return props.theme.primaryColor;
});
var HOTEL_ITEM_HEIGHT_PX = 32;
var HotelsControl = function HotelsControl(_ref2) {
  var allHotels = _ref2.allHotels,
    countryID = _ref2.countryID,
    hotels = _ref2.hotels,
    loading = _ref2.loading,
    selectedHotelsIDs = _ref2.selectedHotelsIDs,
    onAddHotels = _ref2.onAddHotels,
    onClear = _ref2.onClear,
    onToggleHotel = _ref2.onToggleHotel;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  var search = (0, _reactRedux.useSelector)(_selectors.getSearchHotelsString);
  var openCollectionsModal = function openCollectionsModal() {
    return dispatch((0, _SelectForSearchCollectionsModal.showSelectForSearchCollectionsModal)(function (nextSeletedHotels) {
      return onAddHotels(R.concat(selectedHotelsIDs, stringifyHotelsFromCollection(nextSeletedHotels)));
    }, {
      countryID: Number(countryID),
      selectedHotels: hotelToNumbers(selectedHotelsIDs)
    }));
  };
  var handleClearSearchingInput = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.clearSearchHotelsString)());
  }, [dispatch]);
  var handleChangeSearchingInput = (0, _react.useCallback)(function (nextSearch) {
    return dispatch((0, _actions.setSearchHotelsString)(nextSearch));
  }, [dispatch]);
  var selectedHotels = (0, _react.useMemo)(function () {
    return R.filter(function (_ref3) {
      var id = _ref3.id;
      return R.includes(id, selectedHotelsIDs);
    }, allHotels);
  }, [allHotels, selectedHotelsIDs]);
  var activeHotels = (0, _react.useMemo)(function () {
    return R.call(R.pipe(R.filter(function (_ref4) {
      var id = _ref4.id;
      return !R.includes(id, selectedHotelsIDs);
    }), searchHotelsByString(search)), hotels);
  }, [hotels, search, selectedHotelsIDs]);
  var scrollableElementRef = (0, _react.useRef)();
  var rowVirtualizer = (0, _reactVirtual.useVirtualizer)({
    count: activeHotels.length,
    getScrollElement: function getScrollElement() {
      return scrollableElementRef.current;
    },
    estimateSize: function estimateSize() {
      return HOTEL_ITEM_HEIGHT_PX;
    }
  });
  var isEmptyHotels = R.isEmpty(activeHotels);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.container, _defineProperty(_defineProperty({}, _styles.default.noSelected, R.isEmpty(selectedHotels)), _styles.default.mobileContent, loading || isEmptyHotels)),
    "data-length": activeHotels.length
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.header
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    className: _styles.default.label,
    clickable: false,
    text: t('HOTEL_CONTROL_LABEL')
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.collectionsWrapper
  }, /*#__PURE__*/_react.default.createElement(CollectionsModalTrigger, {
    className: _styles.default.collections,
    onClick: openCollectionsModal
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.heartIcon
  }, /*#__PURE__*/_react.default.createElement(_HeartIcon.default, null)), t('OPEN_COLLECTIONS_MODAL_AT_HOTEL_CONTROL')))), /*#__PURE__*/_react.default.createElement(_Input.default, {
    placeholder: t('HOTEL_SEARCH_CONTROL_LABEL'),
    value: search,
    onChange: handleChangeSearchingInput,
    onClear: handleClearSearchingInput
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.lists
  }, loading && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.loadingContainer
  }, /*#__PURE__*/_react.default.createElement(_CircleLoader.default, null)), !loading && isEmptyHotels && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.messageContainer
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, null, t('EMPTY_STATE_AT_HOTEL_CONTROL'))), !loading && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.checkboxList,
    ref: scrollableElementRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.checkboxListInner,
    style: {
      height: "".concat(rowVirtualizer.getTotalSize(), "px")
    }
  }, R.map(function (virtualItem) {
    var hotel = activeHotels[virtualItem.index];
    return /*#__PURE__*/_react.default.createElement("div", {
      key: virtualItem.key,
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: "".concat(virtualItem.size, "px"),
        transform: "translateY(".concat(virtualItem.start, "px)")
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.checkboxItem
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      checked: R.includes(selectedHotelsIDs, hotel.id),
      label: /*#__PURE__*/_react.default.createElement(HotelName, {
        cityName: hotel.cityName,
        districtName: hotel.districtName,
        name: hotel.name,
        secondaryStars: hotel.secondaryStars,
        stars: hotel.stars
      }),
      onChange: function onChange() {
        return onToggleHotel(hotel.id);
      }
    })));
  }, rowVirtualizer.getVirtualItems())), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.selectedListDivider
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.divider,
    onClick: onClear
  }, selectedHotels.length >= 3 && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.clearHotelsButton
  }, t('CLEAR_SEARCH_BUTTON_AT_HOTEL_CONTROL'), /*#__PURE__*/_react.default.createElement("span", null, "\xD7")))), !R.isEmpty(selectedHotels) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.selectedList
  }, R.map(function (hotel) {
    return /*#__PURE__*/_react.default.createElement(StyledSelectedItem, {
      className: _styles.default.selectedItem,
      key: hotel.id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.selectedName
    }, /*#__PURE__*/_react.default.createElement(HotelName, {
      cityName: hotel.cityName,
      districtName: hotel.districtName,
      name: hotel.name,
      stars: hotel.stars
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.selectedClose,
      onClick: function onClick() {
        return onToggleHotel(hotel.id);
      }
    }, "\xD7"));
  }, selectedHotels)), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.selectedListDivider
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.divider,
    onClick: onClear
  }, selectedHotels.length >= 3 && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.clearHotelsButton
  }, t('CLEAR_SEARCH_BUTTON_AT_HOTEL_CONTROL'), /*#__PURE__*/_react.default.createElement("span", null, "\xD7"))))));
};
HotelsControl.propTypes = {
  countryID: _propTypes.default.string.isRequired,
  selectedHotelsIDs: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  onAddHotels: _propTypes.default.func.isRequired,
  onClear: _propTypes.default.func.isRequired,
  onToggleHotel: _propTypes.default.func.isRequired,
  loading: _propTypes.default.bool
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(HotelsControl);